<template>
  <a-button
    :loading="loading"
    @click="onExport"
    :type="btnType"
    :disabled="selectedIds.length === 0"
  >
    <slot>导出</slot></a-button
  >
</template>

<script lang="ts">
import { computed, defineComponent, ref, watch } from "vue";
import { ExportBtnService } from "./export-btn.service";
import { message } from "ant-design-vue";
import _ from "lodash";
export default defineComponent({
  isGlobal: true,
  name: "ExportBtn",
  props: {
    selectedIds: {
      type: Array,
      default: () => [],
    },
    api: {
      type: String,
    },
    queryRef: {
      type: Object,
      default: () => {
        return {};
      },
    },
    btnType: {
      type: String,
      default: "default",
    },
    tableColumn: {
      type: Array,
      default: () => [],
    },
    externalParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isRecycled: {
      type: [Number, Boolean],
      default: 0,
    },
    method: {
      type: String,
      default: "POST",
    },
  },
  setup(props) {
    let loading = ref(false);
    const onExport = async () => {
      if (!props.selectedIds || !props.selectedIds.length) {
        // console.log(props);
        message.warning("请先选择要导出的内容");
        return;
      }
      // console.log("🚀 ~ file: index.vue:81 ~ onExport ~ arr:", props.tableColumn);

      try {
        loading.value = true;
        const { run } = ExportBtnService.useExportApi();
        let params = _.cloneDeep(props.queryRef);
        params.ids = props.selectedIds;
        let res = await run(props.api, {
          ...params,
          ...props.externalParams,
          titleParamReqs: props.tableColumn,
          isRecycled: Number(props.isRecycled),
        },props.method);
        if (res.respCode !== "0000") {
          message.error(res.respDesc);
          return;
        }
        message.success(res.respDesc);
        if (res.data && res.data.url) {
          window.open(res.data.url);
        }
      } finally {
        loading.value = false;
      }
    };
    return {
      onExport,
      loading,
    };
  },
});
</script>

<style scoped></style>
